// Label dictionary metadata (plan 9.2) extracted from the mockup App.labels: label key → glossary slug.
// The text itself lives in the "labels" namespace as `label.<key>`. Edit by hand from now on.

export interface LabelMeta {
  /** Glossary slug: when present, the label is drawn as a term toggletip button. */
  slug?: string;
}

export const LABELS: Readonly<Record<string, LabelMeta>> = {
  "conversation": { slug: "conversation" },
  "prompt": { slug: "prompt" },
  "aiAnswer": { slug: "ai-answer" },
  "contentText": { slug: "content-text" },
  "usage": { slug: "token" },
  "inputTokens": { slug: "input-tokens" },
  "cacheRead": { slug: "cache-read" },
  "cacheWrite": { slug: "cache-write" },
  "outputTokens": { slug: "output-tokens" },
  "reasoningTokens": { slug: "reasoning-tokens" },
  "model": { slug: "model" },
  "effort": { slug: "reasoning-effort" },
  "activeTime": { slug: "active-time" },
  "sessionDuration": { slug: "session-duration" },
  "latency": { slug: "latency" },
  "latencyTypical": { slug: "latency" },
  "latencySlow": { slug: "latency" },
  "toolCall": { slug: "tool-call" },
  "filesOpened": { slug: "accessed-files" },
  "filesEdited": { slug: "accessed-files" },
  "diff": { slug: "diff" },
  "toolDecision": { slug: "tool-decision" },
  "usageMethod": { slug: "usage-method" },
  "methodCli": { slug: "usage-method" },
  "methodApi": { slug: "usage-method" },
  "entrypoint": { slug: "entrypoint" },
  "recordingLevel": { slug: "recording-level" },
  "viewScope": { slug: "view-scope" },
  "auditLog": { slug: "audit-log" },
  "collectionStatus": { slug: "collection-status" },
  "connect": { slug: "connect" },
  "quiet": { slug: "connection-status" },
  "estimatedCost": { slug: "estimated-cost" },
  "roleAdmin": { slug: "role" },
  "roleManager": { slug: "manager" },
  "roleMember": { slug: "role" },
  "contentReviewer": { slug: "content-reviewer" },
  "logReviewer": { slug: "log-reviewer" },
  "noRecord": { slug: "no-record-reason" },
  "partial": { slug: "partial-record" },
};
